import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "d-flex X_flex-wrap X_flex-md-nowrap align-items-center flex-grow-1",
  style: {"min-height":"31px"}
}
const _hoisted_2 = { class: "align-self-start" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-spin fa-spinner" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-exclamation-triangleX fa-ban" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = {
  key: 2,
  class: "text-success"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-check" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 3,
  class: "text-warningX text-danger"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-banX fa-times" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Anmeldeinformationen werden geladen...")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Du bist angemeldet.")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("Du bist nicht angemeldet.")
const _hoisted_18 = { class: "text-nowrap" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "text-nowrap" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-info-circleX fa-exclamation-triangle" }),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("span", { class: "fst-italic" }, "abgesagt")
], -1)
const _hoisted_20 = {
  key: 1,
  class: "text-nowrap"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-hourglass-half" }, null, -1)
const _hoisted_22 = {
  key: 0,
  class: "bf-user-course-upcoming-appointment__col-action pe-1 mb-2 mb-md-0"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-exclamation-triangle me-1" }, null, -1)
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Jetzt anmelden ")
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["d-flex flex-wrap flex-md-nowrap justify-content-start align-items-start bf-user-course-upcoming-appointment", {'opacity-60': _ctx.isPast}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Popper, {
          hover: true,
          arrow: true
        }, {
          content: _withCtx(() => [
            (_ctx.enrollmentLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_15
                ], 64))
              : (_ctx.isCancelled)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createTextVNode(_toDisplayString(_ctx.appointment.cancel_notice || 'Keine weiteren Informationen zur Absage hinterlegt.'), 1)
                  ], 64))
                : (_ctx.isEnrolled)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      _hoisted_16
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                      _hoisted_17
                    ], 64))
          ]),
          default: _withCtx(() => [
            (_ctx.enrollmentLoading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, _hoisted_5))
              : (_ctx.isCancelled)
                ? (_openBlock(), _createElementBlock("span", _hoisted_6, _hoisted_8))
                : (_ctx.isEnrolled)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, _hoisted_11))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, _hoisted_14))
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("span", {
          class: _normalizeClass([{'text-decoration-line-through': _ctx.isCancelled, 'fst-italic': _ctx.renderTextItalic}, "ms-1"])
        }, [
          _createTextVNode(_toDisplayString(_ctx.date) + " ", 1),
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.timeStart) + " Uhr", 1)
        ], 2),
        (_ctx.isCancelled)
          ? (_openBlock(), _createBlock(_component_Popper, {
              key: 0,
              hover: true,
              arrow: true
            }, {
              content: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.appointment.cancel_notice || 'Keine weiteren Informationen zur Absage hinterlegt.'), 1)
              ]),
              default: _withCtx(() => [
                _hoisted_19
              ]),
              _: 1
            }))
          : (_ctx.timeToStart)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                _hoisted_21,
                _createTextVNode(" " + _toDisplayString(_ctx.timeToStart), 1)
              ]))
            : _createCommentVNode("", true)
      ])
    ]),
    (!_ctx.isCancelled && !_ctx.enrollmentLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          (_ctx.isEnrolled)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                href: "#",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onEnrollClick && _ctx.onEnrollClick(...args)), ["prevent"])),
                class: "btn btn-sm btn-secondary",
                style: {"width":"96px"}
              }, "Abmelden"))
            : (_ctx.isWaitingAndCanEnroll)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onEnrollClick && _ctx.onEnrollClick(...args)), ["prevent"])),
                  class: "btn btn-sm btn-success",
                  style: {"width":"154px"}
                }, _hoisted_25))
              : (_ctx.isWaiting)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    href: "#",
                    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onEnrollClick && _ctx.onEnrollClick(...args)), ["prevent"])),
                    class: "btn btn-sm btn-danger",
                    style: {"width":"96px"}
                  }, "Warteliste"))
                : (_openBlock(), _createElementBlock("a", {
                    key: 3,
                    href: "#",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onWithdrawClick && _ctx.onWithdrawClick(...args)), ["prevent"])),
                    class: "btn btn-sm btn-primary",
                    style: {"width":"96px"}
                  }, "Anmelden"))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}